import { ActionType } from '@quorum/models/xs-resource'
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';
import { svcDropdownsFeatureSelector } from '../svc-dropdowns-feature.selector';
export interface ActionTypesState extends EntityState<ActionType> {}

export const actionTypesAdapter: EntityAdapter<ActionType> = createEntityAdapter<ActionType>({
  selectId: (actionType: ActionType) => actionType.id
});

export const initialState: ActionTypesState = actionTypesAdapter.getInitialState();

export const actionTypesSelector = createSelector(
  svcDropdownsFeatureSelector,
  (state: any) => state.actionTypes
);

export const { selectIds, selectEntities, selectAll, selectTotal } = actionTypesAdapter.getSelectors(
  actionTypesSelector
);
